<template>
  <div class="ma-4">
  <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
  <v-card>
      <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
        <v-flex xs10>
          <v-btn fab x-small @click="$router.go(-1)">
            <v-icon>navigate_before</v-icon>
              
            </v-btn>
        </v-flex>
        
        <v-flex xs2>
          <report-list-actions
          :reportOptions="reportOptions"
          :downloadFilename="reportListFilename"
          ></report-list-actions>
        </v-flex>

            <v-flex xs12>
              <h3 class="text-center mb-5">Client Inventory Report</h3>
              <v-divider class="ml-4 mr-4 mb-3"></v-divider>
            </v-flex>
            
            <v-flex xs12 md2 class="pa-1">
                <v-menu
                    ref="calendarMenu"
                    v-model="calendarMenu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="filters.startDate"
                        label="Start Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules='requiredField'
                        clearable
                    ></v-text-field>
                    </template>
                    <v-date-picker
                    v-model="filters.startDate"
                    no-title
                    scrollable
                    :rules='requiredField'

                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="calendarMenu = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs.calendarMenu.save(date)"
                    >
                        OK
                    </v-btn>
                    </v-date-picker>
                </v-menu>
                
            </v-flex>

            <v-flex xs12 md2 class="pa-1">
               <v-menu
                    ref="calendar2Menu"
                    v-model="calendar2Menu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="filters.endDate"
                        label="End Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules='requiredField'
                        clearable

                    ></v-text-field>
                    </template>
                    <v-date-picker
                    v-model="filters.endDate"
                    no-title
                    scrollable
                    :rules='requiredField'

                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="calendar2Menu = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs.calendar2Menu.save(date)"
                    >
                        OK
                    </v-btn>
                    </v-date-picker>
                </v-menu>
            </v-flex>            

            <v-flex xs12 md2  class="pa-1 mb-2">
              <v-select
                label="Client Status"
                :items="clientStatuses"
                v-model="filters.clientStatus"
                clearable
                ></v-select>
            </v-flex>

            <v-flex xs12 md3 class="pa-1 mb-2">
              <v-select 
                  label="Select Client"
                  :items="filteredClients"
                  item-text="Name"
                  item-value="_id"
                  v-model="filters.ClientID"
                  clearable
                ></v-select>
            </v-flex>

            <!-- <v-flex xs12 md2 class="pa-1 mb-2">
              <v-select 
                  label="Status"
                  :items="list"
                  v-model="signatureBool"
                  clearable
                ></v-select>
            </v-flex> -->

            <v-flex xs12 md3 class="mt-5 mb-5 pl-5">
               <v-btn @click="inventoryQuery()">Search</v-btn>
            </v-flex>

            <v-flex xs12 class="pa-2">
                <v-data-table
                  :headers="headers"
                  :items="inventories"
                  sort-by="Date"
                  sort-asc
                  class="elevation-1"
                  :loading="isLoading"
                  loading-text="Loading Client Inventory"
                  :page="page"
                  :pageCount="pageCount"
                  :server-items-length="itemCount"
                  :options.sync="options"
                >
                <template v-slot:item.select="{ item }">
                  
                    <v-btn
                      x-small
                      class="white--text"
                      color="#2b3990"
                      @click="viewInventory(item)"
                    >
                      View
                    </v-btn>
                             
                </template>
                </v-data-table>

                <v-dialog v-model="dialog" max-width="80%">
                  <v-card>
                    <v-card-title style="background-color: #2b3990">
                      <span class="headline white--text">{{ titleForm  }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="4">
                            <v-menu
                              ref="menu2"
                              v-model="menu2"
                              :close-on-content-click="false"
                              :return-value.sync="date"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="newDateAdded"
                                  label="Date Added"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  clearable
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="newDateAdded" no-title scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="menu2 = false">
                                  Cancel
                                </v-btn>
                                <v-btn text color="primary" @click="$refs.menu2.save(date)">
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" sm="12" md="4">
                            <v-text-field label="Item Name" v-model="newItem"></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="6" md="4">
                            <v-text-field
                              label="Value of Item"
                              v-model="newValue"
                              prefix="$"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12">
                            <span>Item Description</span>
                            <div>{{ newDescription }}</div>
                          </v-col>
                          <v-col class="d-flex" cols="12" sm="12" md="6">
                            <v-file-input
                              v-model="newImage"
                              class="pa-2"
                              label="New Image"
                              show-size
                              filled
                              multiple
                              prepend-icon="mdi-camera"
                              accept="image/*"
                              @change="imgSelected"
                            >
                              <template #selection="{ text, index }">
                                <v-chip
                                  small
                                  label
                                  close
                                  color="primary"
                                  @click:close="deleteChip(index)"
                                  >{{ text }}</v-chip
                                >
                              </template>
                            </v-file-input>
                          </v-col>
                          
                          <v-col class="d-flex" cols="12" sm="12">
                            <div v-if="newImage.ext != 'pdf'">
                              <img :src="newImageLink" height="480" width="550" />
                            </div>
                          </v-col>
                          <v-col class="d-flex" cols="12" sm="12">
                            <v-text-field
                              v-model="newEnteredBy"
                              label="Entered By"
                              readonly
                              @click="addSignature"
                            ></v-text-field>
                          </v-col>
                          <div>Staff Signature</div>
                          <v-col cols="12" sm="12">
                            <img :src="digitalSignature" height="200" width="200" />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <!-- <v-btn color="blue darken-1" text @click="updateTraining()" v-if="editTraining">Update</v-btn
                      > -->
                      <v-btn color="blue darken-1" text @click="close">Close</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

            </v-flex>
        </v-layout>
      </v-card>
  </div>
</template>
<script>
import axios from 'axios'
import { STATUS_ARRAY } from '../../enums/UserStatusEnum';
import { DateTime } from 'luxon';
import ReportListActions from '@/components/Report/ReportListActions.vue';
// import { PDFDocument } from "pdf-lib";
// import moment from 'moment'
// import Foot from '../components/Footer'

const url = require("../../client_config/config").url;

export default {
  components: {
    ReportListActions
  },
  data: () => ({
  headers: [
    {
       text: 'Client',
       align: 'start',
       sortable: true,
       value: 'ClientInfo.Name',
    },
    { text: "Item", value: "Item" },
    { text: "Date Added", value: "DateAdded" },
    { text: "Description", value: "Description" },
    { text: "Value", value: "Value" },
    { text: "EnteredBy", value: "EnteredBy" },
    { text: "", value: "select" },
  ],
  date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
  employees: [],
  inventories: [],
  dialog: false,
  calendarMenu: false,
  calendar2Menu: false,
  menu: false,
  menu2: false,
  report: '',
  staff: '',
  // clientName: '',
  isLoading: false,
  signed: false,
  role: localStorage.getItem('userRole'),
  state: localStorage.getItem('userState'),
  requiredField: [
      v => !!v || 'This is required',
  ],
  editInventory: false,
  newInventory: false,
  msg: false,
  search: "",
  text: "",
  tempData: [],
  clients: [],
  userID: localStorage.getItem("userID"),
  titleForm: "New Inventory Item",
  inventoryID: "",
  newDateAdded: "",
  newValue: "",
  newDescription: "",
  newImage: [],
  imageDetails: [],
  newImageLink: "",
  newEnteredBy: "",
  newStaffSignature: "",
  inventorySignaturepad: false,
  newItem: "",
  canDelete: false,
  directCare: false,
  digitalSignature: '',
  clientStatuses: STATUS_ARRAY,
  options: {},
  page: 1,
  pageCount: 1,
  itemCount: 0,
  filters: {
    startDate: '',
    endDate: '',
    clientStatus: '',
    ClientID: '',
  }
  

  }),

  computed: {
    clientName() {
      // `this` points to the component instance
      return this.$store.state.clients.client.Name;
    },
    
    
    filteredClients() {
      let clients = this.clients;
      
      if (this?.clientStatus != "" && this.clientStatus) {
        clients = clients.filter((client) => client.Status == this.clientStatus)
      }
      
      return clients;
    },
    
    queryParams() {
      let {page, sortBy, sortDesc, itemsPerPage} = this.options;      
      const sortField = sortBy ? sortBy[0] : 'Date';
      const sortDirection = sortDesc ? sortDesc[0] : 'desc';
      const today = DateTime.now();
      const lastMonth = DateTime.now().minus({months:1});
      let defaultEndDate = today.toFormat('yyyy-MM-dd');
      let defaultStartDate = lastMonth.toFormat('yyyy-MM-dd');

      return {        
        startDate: this.filters.startDate || defaultStartDate,
        endDate: this.filters.endDate || defaultEndDate,
        clientID: this.filters.ClientID,
        state: this.state,
        clientStatus: this.filters.clientStatus,
        page: page,
        limit: itemsPerPage,
        sortField: sortField,
        sortDirection: sortDirection,
        clientId: this.ClientID || ""
      };
    },

    reportOptions() {
      return { 
          query: this.queryParams,
          endpoints: `inventory/report/printList`,
          dynamic: true
      }
    },
    reportListFilename() {
      return `Client Inventory Report`
    }
  },

  created() {
    this.getClients();
    this.getFilters();
    
  }, 
  watch: {
    options: {
        handler() {
            this.inventoryQuery();
        },
        deep: true
    },

    filters: {
        handler() {
            this.setFilters();
        },
        deep: true
    }
  },

  methods: {
    initialize() {
      this.inventories = [];
    },

    getClients () {
      // axios.get(`${url}/clients/state/${this.state}`).then(res => {
      //   this.clients = res.data.clients;
        
      // });

      axios.get(`${url}/clients/`).then(async res => {
        this.clients = res.data.clients;
      });       
    },
    close() {
      this.dialog = false;

    },
    
    inventoryQuery() {
      this.inventories = []
      this.isLoading = true;

      axios.get(`${url}/inventory/report/query`, {
        params: this.queryParams
      }).then(res => {

        const {docs, totalPages, totalDocs} = res.data;
        this.inventories = docs;
        this.pageCount = totalPages;
        this.itemCount = totalDocs;
        this.isLoading = false;
      })
    },

    updateInventory() {
      var req_body = {
        DateAdded: this.newDateAdded,
        Description: this.newDescription,
        Value: this.newValue,
        //Image: this.newImage,
        EnteredBy: this.newEnteredBy,
        StaffSignature: this.digitalSignature,
        Item: this.newItem,
        deletedAt: new Date(),
      };
      axios
        .put(`${url}/inventory/${this.inventoryID}`, req_body)
        .then((response) => {
          // this.getInventories();
          if (response.status == 400) {
            response.json().then(function (data) {
              alert(data.msg);
            });
          }
          this.msg = true;
          this.text = "The inventory Item has been updated successfully.";
          this.saveImg();
        });
      this.close();
    },

    getStaffID(item) {
    this.staff = item.EmployeeID;
    window.localStorage.setItem('staffId', this.staff)
    console.log(this.staff + " is the staff")
  },

  viewInventory(item) {
      this.titleForm = "Viewing " + item.Item;
      this.dialog = true;
      this.editInventory = true;
      this.newInventory = false;
      this.newDateAdded = item.DateAdded;
      this.newDescription = item.Description;
      this.newItem = item.Item;
      this.newValue = item.Value;

      if (item.documents.length > 0) {
        const tempData = [];
        for (let i = 0; i < item.documents.length; i++) {
          let fileExt = item.documents[i].AWSLink.split(".").pop();
          tempData.push({
            name: item.documents[i].Name,
            ext: fileExt,
            id: item.documents[i]._id,
            awsLink: item.documents[i].AWSLink,
          });
        }
        this.newImage = tempData;
        this.newImageLink = this.newImage[0].awsLink;
      }

      this.imageDetails = item.documents;

      this.newEnteredBy = item.EnteredBy;
      this.digitalSignature = item.StaffSignature;
      this.inventoryID = item._id;
      console.log(item)
    },

    imgSelected(e) {
      this.uploadImg = e;
    },

    saveImg() {
      this.message = "";
      for (let i = 0; i < this.uploadImg.length; i++) {
        this.uploadFiles(this.uploadImg[i]);
      }
    },

    uploadFiles(file) {
      const formData = new FormData();
      formData.append("inventory-img", file);
      var ct = { headers: { "content-type": "multipart/form-data" } };
      axios
        .post(`${url}/Inventory/imguploader/${this.inventoryID}`, formData, ct)
        .then((res) => {
          if (res) {
            this.getInventories();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    addSignature() {
      this.newEnteredBy = this.staff + " - " + new Date();
    },

    signatureData(data) {
      this.digitalSignature = data;
    },

    deleteChip(index) {
      // Prompt here with text if required
      this.newImage.splice(index, 1);
    },

   printTable() {
      window.print()
    
  },
    getFilters() {
        let filters = localStorage.getItem('clientInventoryReportFilter');
        if (filters) {
            this.filters = JSON.parse(filters);
        }
    },

    setFilters() {
        localStorage.setItem('clientInventoryReportFilter', JSON.stringify(this.filters));
    }
  }
}
</script>
<style>

@media only screen and (min-width: 768px) {
.mobile {
  display: none;
}
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}



@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

}

@media print {
  nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
    display: none;
    border: none; 

  }

  @page { margin: 0; }
  body { margin: 1.6cm; }

  
} 
</style>